import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from '@proget-shared/form/checkbox';
import { InputModule } from '@proget-shared/form/input';
import { TranslateModule } from '@proget-shared/translate';
import { ScrollbarModule } from '@proget-shared/ui/scrollbar';

import { ListboxComponent } from './listbox.component';

@NgModule({
  declarations: [ListboxComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    CheckboxModule,
    InputModule,
    ReactiveFormsModule,
    ScrollbarModule,
  ],
  exports: [ListboxComponent],
})
export class ListboxModule { }
